import React, { createContext, useState } from "react";

const SidebarContext = createContext();

const SidebarContextProvider = ({ children }) => {
  const [sidebars, setSidebars] = useState({});

  const toggleSidebar = (key, isOpen) => {
    setSidebars((prev) => ({ ...prev, [key]: isOpen }));
  };

  return (
    <SidebarContext.Provider
      value={{
        openSidebar: (key) => toggleSidebar(key, true),
        closeSidebar: (key) => toggleSidebar(key, false),
        isSidebarOpen: (key) => !!sidebars[key],
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};

export { SidebarContextProvider, SidebarContext };
